//commentTab.js
import React, { useState, useCallback, useEffect } from "react";
import { DataGrid, Column, Lookup, Item } from "devextreme-react/data-grid";
import useGetCommentsForOrderId from "../../../../Hooks/useGET/useGetCommentsForOrderId";
import { Button } from "devextreme-react/button";
import CommentForm from "./commentForm";
import ActionNotifications from "../../../../Components/ActionNotifications";

export default function CommentTab(orderId) {
  const { allComments } = useGetCommentsForOrderId(orderId);
  const [notifyResponse, setResponse] = useState({});
  useEffect(() => {
    console.log("notifyResponse", notifyResponse);
  }, [notifyResponse]);
  const [showPopup, setPopup] = useState({
    commentForm: null,
  });

  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };
  const handlePopup = useCallback((popupKey, data) => {
    console.log("handlePopup data", data);
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: { data },
    }));
  }, []);
  const handleClose = (popupKey) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: null,
    }));
  };
  return (
    <>
      <ActionNotifications response={notifyResponse} />
      {showPopup.commentForm && (
        <CommentForm
          orderId={showPopup.commentForm.data}
          setNotifications={setResponse}
          onClose={() => handleClose("commentForm")}
        />
      )}
      <div
        style={{
          margin: "10px 0px 10px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button
          text="Add Comments"
          type="normal"
          stylingMode="contained"
          icon="add"
          onClick={() => handlePopup("commentForm", orderId)}
        />
      </div>
      <DataGrid
        dataSource={allComments}
        showBorders={true}
        columnAutoWidth={true}
        maxHeight="300px"
        elementAttr={{ class: "history-grid" }}
      >
        <Column dataField="date" dataType="datetime" defaultSortOrder="desc" />
        <Column dataField="name" />
        <Column dataField="comment" />
        <Column dataField="id" visible={false} />
      </DataGrid>
    </>
  );
}
